import React, { useRef } from "react";

import PageBanner from "../../layouts/PageBanner"; 
 
import president from "../../assets/images/TheSigningOfficers/sats_president.jpg"
import ApiServer from "../../helpers/Api_help";

 

const Announcement = () => { 
 
  return (
    <>
      <div className="page-content bg-white">
        <PageBanner maintitle="Home" pagetitle="PRESIDENT’S MESSAGE" />
        <section className="content-inner-2 section-wrapper5">
          <div className="container text-dark">
            <div className="row align-items-center">
              <div
                className="col-lg-12 d-flex flex-wrap justify-content-between align-items-center
              "
              >
                <div className="section-head col-lg-6 col-md-6 col-sm-12">
                   <h3>
                    Vanakkam!
                    <br />
                   
                  </h3>
                  
                  <p className="m-t20 text-justify">
                    It is my honor and privilege to serve as the President of
                    San Antonio Tamil Sangam (SATS), an organization that truly
                    embodies the spirit of unity in diversity. Having served our
                    community for 30-years, our Sangam is more than a cultural
                    association—it is a family where every voice matters, every
                    tradition is valued, and every generation finds inspiration.
                    <br/>
                    At SATS, we take pride in fostering our rich Tamil heritage
                    while embracing the multicultural spirit of San Antonio.
                    Through music, dance, language, and festivals, we create
                    opportunities for our children and families to stay
                    connected to our roots while celebrating the beauty of
                    diversity around us.
                     <br/>
                      Equally important is our commitment to
                    serving the community. From cultural programs and
                    educational workshops to charitable initiatives, SATS
                    strives to give back in meaningful ways. We firmly believe
                    in nurturing our children not just in academics and the
                    arts, but also in respecting others, valuing differences,
                    and growing as compassionate individuals.
                     <br/>
                      As we look ahead,
                    our vision is to strengthen this platform where culture,
                    service, and community come together in harmony. I warmly
                    invite you to join hands with us—whether it’s volunteering,
                    performing, teaching, or simply being present—to make every
                    initiative of SATS impactful and memorable. <br/> Our Corporate &
                    Individual Sponsors, past SATS Presidents & Executive
                    Committee Teams, Volunteers, Members, Tamil Enthusiasts, and
                    Well Wishers are the greatest strength of our Sangam. My
                    heartfelt thanks to them.  <br/>Together, let us celebrate our
                    heritage, uplift one another, and build a stronger community
                    for the future. <br/> Best Regards, <br/> 
                    <span style={{fontWeight: 600,color: "#000",}}>Dr.Yuvaraj</span>
                     <br/> San Antonio Tamil Sangam (SATS)
                  </p>
                </div>
                <div className="col-lg-5 col-md-5 col-sm-12 ">
                  {/* <img src={president} alt="president" /> */}
                  {/* D:\sats_testing_git_web\SATS_Dev_Web_EndUser\src\assets\images\TheSigningOfficers\sats_president.jpg */}
                  <img
  src={`${ApiServer}assets/committee/sats_president.jpg`}
  alt="president"
/>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Announcement;
